/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>入库订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <!-- <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期时间"
          @change="getData(date)"
          default-time="12:00:00"
        >
        </el-date-picker> -->
        <el-date-picker
          v-model="date"
          type="daterange"
          @change="getData(date)"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addCount"
          >添加入库</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="exportStorage"
          >导出</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          plain
          icon="el-icon-guide"
          size="mini"
          @click="dialogVisible = true"
          >上传入库单
        </el-button>
      </el-form-item>

      <el-form-item>
        <el-dialog
          title="上传入库单"
          :visible.sync="dialogVisible"
          width="400px"
          :before-close="handleClose"
        >
          <el-upload
            class="upload-demo"
            drag
            name="flie"
            :http-request="uploadFile1"
            :headers="headers1"
            action=""
            multiple
          >
            <!-- :http-request="uploadFile1" -->

            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">只能上传excel文件</div>
          </el-upload>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false"
              >退 出</el-button
            >
          </span>
        </el-dialog>
        <!-- <el-upload
          accept=".xlsx"
          :limit="limitNum"
          class="upload-demo"
          :action="UploadUrl()"
          :on-change="handleChange"
          :file-list="fileList"
          :on-success="handleSuccess"
          :on-error="handleError"
        >
          <el-button size="small" type="primary" @click="uploadFile"
            >点击上传入库单</el-button
          >
          <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload> -->
        <!-- <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="upLoadStorage"
          >上传入库单</el-button
        > -->
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="success"
          icon="el-icon-download"
          @click="DownMoBan"
          >下载上传模版</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="goodsList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <!-- </el-table-column> -->
      <el-table-column
        prop="totalCostPrice"
        label="总零售价"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="stock" label="入库数量" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="salePrice" label="入库金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="profit" label="利润" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @click="closeDialog('editForm')"
      close="closeDialog"
    >
      <el-form label-width="250px" :model="editForm" ref="editForm">
        <el-row>
          <el-col>
            <el-table :data="editForm" style="width: 100%">
              <el-table-column prop="name" label="商品名称" width="180">
              </el-table-column>
              <el-table-column prop="salePrice" label="零售价">
              </el-table-column>
              <el-table-column prop="number" label="数量"> </el-table-column>
              <el-table-column
                prop="gross_weight"
                label="毛重"
              ></el-table-column>
              <el-table-column prop="costPrice" label="进货价">
              </el-table-column>
              <el-table-column prop="barcode" label="条码"> </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";
import { saveAs } from "file-saver";

import {
  getGoodsList,
  getGoodsTypeList,
  getGoodsDetail,
  editGoodsInfo,
  getStorageRecord, //获取入库记录
  getStorageDetail, //获取入库记录详情
  uploadFile2, //上传入库单
  blobValidate,
} from "@/api/api.js";

export default {
  data() {
    return {
      dialogVisible: false,

      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        // responseType: 'blob',
      },
      headers1: {
        "Content-Type": "application/x-www-form-urlencoded",
        token: window.localStorage.getItem("token"),
        storeId: localStorage.getItem("storeId"),
      },
      limitNum: 1,
      fileList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      goodName: "", //商品名称
      goodsList: [], //商品列表
      options: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ], //预下架选项
      editForm: {
        alarmInventory: "",
        barcode: "",
        costPrice: "",
        inventoryStock: "",
        name: " ",
        platformGoodsId: "",
        preTakedown: "",
        salePrice: "",
        stock: "",
        storeId: "",
        typeId: "",
        url: "",
        vipPrice: "",
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let date = new Date();
    this.date = date;
    // this.getdata(this.formInline);
    this.getGoodsType(); //获取商品类型列表
    this.getData(date); //获取盘点单列表
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    uploadFile1(param) {
      // this.$modal.loading("正在上传文件，请稍候...");
      // 获取上传的文件名
      var file = param.file;
      //发送请求的参数格式为FormData
      const formData = new FormData();
      formData.append("file", file);
      // this.download('common/upload/excel', {}, `未保存数据库里数据_${new Date().getTime()}.xlsx`)
      uploadFile2(formData).then(() => {});

      // })

      //   async (res) => {
      //   console.log(res);
      //   const isLogin = await blobValidate(res);
      //   if (isLogin) {
      //     console.log(new Blob([res]));
      //     const blob = new Blob([res]);
      //     saveAs(blob, `excel重复数据_${new Date().getTime()}.xlsx`);
      //     // this.$modal.msgSuccess("上传成功");
      //     this.$message({
      //       type: "success",
      //       message: "上传成功",
      //     });
      //   } else {
      //     const resText = await res.text();
      //     const rspObj = JSON.parse(resText);
      //     const errMsg =
      //       errorCode[rspObj.code] || rspObj.msg || errorCode["default"];
      //     // this.$modal.msgError(errMsg);
      //         this.$message.error("导出失败");

      //   }
      //   // this.$modal.closeLoading();
      // })
      // .catch((r) => {
      //   console.error(r);
      //   // this.$modal.msgError("上传失败，请重试");
      //   // this.$modal.closeLoading();
      //   this.$message.error("导出失败");
      // });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // uploadFile() {
    //   const token = localStorage.getItem("token");
    //   let form = new FormData();
    //   form.append("file", this.fileList);
    //   this.$axios({
    //     method: "post",
    //     url:
    //       "https://ht.wteam.club/api/system/businessgoods/uploadInboundExcel",
    //     headers: {
    //       "Content-type": "multipart/form-data",
    //       token: token,
    //     },
    //     data: form,
    //   }).then(
    //     (res) => {},
    //     (err) => {}
    //   );
    // },

    // 上传入库单
    handleChange() {},
    // 下载上传模版
    DownMoBan() {
      const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        token: localStorage.getItem("token"),
      };
      this.$confirm("确定下载上传模版吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              `https://ht.wteam.club/api/system/businessgoods/export/InboundModel`,
              {
                headers: headers,
                responseType: "blob",
              }
            )
            .then(async (res) => {
              console.log(res, "33333");
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `下载上传模版_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "下载成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("下载失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下载",
          });
        });
    },
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取盘点单列表
    getData(date) {
      if (date != null) {
        localStorage.setItem("ruku", date);

        localStorage.setItem("ruku1", date[0]);
        localStorage.setItem("ruku2", date[1]);
      }
      this.loading = true;
      if (localStorage.getItem("ruku") == null) {
        this.date = date;
      } else {
        this.date[0] = localStorage.getItem("ruku1");
        this.date[1] = localStorage.getItem("ruku2");
      }
      // //转化日期的格式
      // let data1 = new Date(date);
      // this.startTime =
      //   data1.getFullYear() +
      //   "-" +
      //   ("0" + (data1.getMonth() + 1)).slice(-2) +
      //   "-" +
      //   ("0" + data1.getDate()).slice(-2);
      getStorageRecord({
        create_time: this.date[0],
        end_time: this.date[1],
        pageNum: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        //改变数组里元素的某个属性
        // res.data.records.forEach((item)=>{
        //   item.payMethod = item.payMethod == 0 ? '微信' : '支付宝'
        //   item.orderStatus = item.orderStatus == 1 ? '已完成' : '生成中'
        //   item.newContent = item.content.replace(/\\n/g, '<br>')
        // })
        this.goodsList = res.data.data;
        //给每一个元素添加一个属性
        this.goodsList.forEach((item) => {
          item.profit = item.salePrice - item.totalCostPrice;
        });
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.count;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.formInline.limit = parm.pageSize;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 添加订单
    addCount() {
      //跳转路由
      this.$router.push({
        path: "/goods/addStorage",
      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      //获取盘点单详情
      getStorageDetail(row.id).then((res) => {
        this.editForm = res.data.data;
      });
      //   console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm() {
      //修改商品信息
      editGoodsInfo(this.editForm).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "商品信息修改成功!",
          });
          this.editFormVisible = false;
          this.getData();
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      console.log(2222222);
      this.editFormVisible = false;
      // this.$refs[formName].resetFields();
      this.editForm = {};
    },
    //导出入库管理
    exportStorage() {
      // let startDate = new Date(this.date);
      // this.date =
      //   startDate.getFullYear() +
      //   "-" +
      //   ("0" + (startDate.getMonth() + 1)).slice(-2) +
      //   "-" +
      //   ("0" + startDate.getDate()).slice(-2);
      this.$confirm("确定导出入库订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              `https://ht.wteam.club/api/system/businessgoods/export
?storeId=${localStorage.getItem("storeId")}&create_time=${
                this.date[0]
              }&end_time=${this.date[1]}&inboundType=${0}`,
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                  token: localStorage.getItem("token"),
                },
                responseType: "blob",
              }
            )
            .then(async (res) => {
              console.log(res, "33333");
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `商品列表_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "导出成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("导出失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/goods/storage.vue